
import { Constant } from "@/helpers/constant";
import { Component, Vue, Prop } from "vue-property-decorator";
import { TranslateMalay}  from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";
@Component
export default class Footer extends Vue {

  @Prop({ default: [] })
  routePath: string;
  upskillAgencyLoginUrl = Constant.upskill_agency_login_url;
  upskillAgencyMLoginUrl = Constant.upskill_Mlogin_url;
  selectedLanguage : string ='';
  footerData : any;
  currentYear: any;
  viewPrivacyPolicy(){
  let route = this.$router.resolve({path: '/privacyPolicy'});
  window.open(route.href, '_blank');
}

created()
{
this.selectedLanguage = localStorage.getItem("selectedlanguage");
if(this.selectedLanguage == 'en')
{
  this.footerData = TranslateEn.footerDataNew;
}
else
{
  this.footerData = TranslateMalay.footerDataNew;
}
this.currentYear = new Date().getFullYear();
}

viewAboutus(){
 let route = this.$router.resolve({path: '/aboutus'});
  window.open(route.href, '_blank');  
}
  redirectToAdminLogin() {
    this.$router.push("/admin");
  }
    redirectToJobSeekerLogin() {
    localStorage.removeItem("loginType");
    this.$router.push("/individualLogin");
  }

  redirectToEmployerLogin() {
    localStorage.removeItem("loginType");
    this.$router.push("/employerLogin");
  }
}
